export enum CARDS_SIZE {
    small = 1,
    medium = 2,
    big = 3,
}
